module.exports = __webpack_public_path__ + "img/sun-bright.0c936d76.svg";